// VOICE-1: the consent step before a voice print is made. The wording is versioned: the server
// sends the current `consent_version` and refuses an enrolment that echoes an older one, so a
// change here must bump `CONSENT_VERSION` in backend/src/scribe/voiceprints/config.py.
// Have legal review this text before the feature is switched on for everyone.
import { useId, useState } from 'react';

export function VoicePrintConsent({
  speakerName,
  busy,
  error,
  onConfirm,
  onCancel,
}: {
  speakerName: string;
  busy?: boolean | undefined;
  error?: string | null | undefined;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const [agreed, setAgreed] = useState(false);
  const checkboxId = useId();
  return (
    <div className="voice-consent" role="group" aria-label="Voice print consent">
      <p>
        <strong>Use {speakerName}’s voice as your voice print?</strong>
      </p>
      <ul className="muted">
        <li>Scribe makes a voice print from up to 2 minutes of this speaker’s audio.</li>
        <li>
          New recordings then name you automatically when your voice matches. Close matches are
          only suggested.
        </li>
        <li>
          A voice print is biometric data. It is stored encrypted, never shown to anyone, and
          used only to name speakers in Scribe.
        </li>
        <li>You can delete it at any time under Voice print. Deleting it is immediate.</li>
      </ul>
      <label htmlFor={checkboxId} className="row">
        <input
          id={checkboxId}
          type="checkbox"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        />
        This is my voice, and I agree to Scribe making and storing a voice print from it.
      </label>
      {error && <p className="error">{error}</p>}
      <div className="row">
        <button type="button" className="sm" disabled={!agreed || busy} onClick={onConfirm}>
          {busy ? 'Saving…' : 'Make my voice print'}
        </button>
        <button type="button" className="ghost sm" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
